{
  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.js-video');
    videos.forEach(video => {
      const button = video.closest('.video-hero__video-wrapper').querySelector('.mute-toggle-btn');
      const iconPaths = button.querySelectorAll('.sound-cross');

      if (!video || !button) return;

      video.muted = true;
      iconPaths.forEach(path => path.style.display = 'block');

      button.addEventListener('click', function () {
        if (video.muted == true) {
          video.muted = false;
          iconPaths.forEach(path => path.style.display = 'none');
        } else {
          video.muted = true;
          iconPaths.forEach(path => path.style.display = 'block');
        }
      });
    });
  });
}

// image change 
function handleImageChange(item) {
  const getMainDiv = item.closest(".product-item__inner");
  if (!getMainDiv) return;

  const imageHtml = getMainDiv.querySelector(".js-image-wrappers-json");
  if (!imageHtml) return;

  const variantsData = JSON.parse(imageHtml.textContent);
  const clickedVariantId = item.dataset.variantId;

  const matchedVariant = variantsData.find(v =>
    String(v.variant_id).trim() === String(clickedVariantId).trim()
  );

  if (matchedVariant) {
    const quickViewButtonEl = getMainDiv.querySelector(".product-item__quick-view-button");
    const quickViewBaseUrlRaw = quickViewButtonEl?.dataset.url;

    if (quickViewBaseUrlRaw && quickViewButtonEl) {
      const quickViewBaseUrl = quickViewBaseUrlRaw.replace(/(\?|&)variant=\d+/, '');
      const quickViewVariantUrl = `${quickViewBaseUrl}?variant=${clickedVariantId}`;
      quickViewButtonEl.setAttribute("data-url", quickViewVariantUrl);
    }

    const imageWrapper = getMainDiv.querySelector('.js-media--wrapper');
    if (imageWrapper) {
      imageWrapper.outerHTML = matchedVariant.image_wrapper;
    }
  }
}
setTimeout(() => {
  document.querySelectorAll(".js-image-change").forEach((item) => {
    item.addEventListener("click", (e) => {
      // Don't interfere with cross-sells variant switching
      if (item.closest('.cross-sells__item')) return;

      item.closest(".js-card-swatch")?.querySelectorAll(".js-image-change").forEach((item) => { 
        item.classList.remove("selected");
      })
      item.classList.add("selected");
      e.preventDefault();
      e.stopPropagation();
      handleImageChange(item);
    });
     
    item.addEventListener("mouseenter", () => {
      // Don't interfere with cross-sells
      if (item.closest('.cross-sells__item')) return;

      let itemInfo = item.closest(".js-item-info");
      item.closest(".js-card-swatch")?.querySelectorAll(".js-image-change").forEach((item) => { 
        item.classList.remove("selected");
        let SlectedSwatch = item.closest(".product-swatches-options__list")?.closest(".product-swatches-options")?.querySelector(".js-selected-swatch")
        if (SlectedSwatch) {
          SlectedSwatch.innerHTML = "";
        }
      })
      item.classList.add("selected");
      let SlectedSwatch = item.closest(".product-swatches-options__list")?.closest(".product-swatches-options")?.querySelector(".js-selected-swatch")
      if (itemInfo && itemInfo.querySelector(".js-variant-title-change")) {
        itemInfo.querySelector(".js-variant-title-change").textContent = item.dataset.variantName;
      }
      if (SlectedSwatch) {
        SlectedSwatch.innerHTML = item.dataset.variantName;
        bundleAddToCart(item)
      }
      handleImageChange(item);
    });
  });
}, 1000);

window.bundleAddToCart = function (item) {
  // adjust selector if bundle-item-list is a class
  const bundleItems = document.querySelectorAll("bundle-item-list");
  if (bundleItems.length > 0) {
    // get the wrapper of the clicked item
    let itemWrapper = item.closest(".product-item__inner");
    let addToCart = itemWrapper.querySelector("add-to-cart.js-Select");
    let soldOutButton = itemWrapper.querySelector("sold-out");
    if (itemWrapper && !item.classList.contains("sold-out-variant")) {
      // find the add-to-cart element (adjust selector if needed)
      if (addToCart) {
        document.querySelectorAll(".product-item__inner").forEach(inner => {
          const innerAddToCart = inner.querySelector("add-to-cart.js-Select");
          if (innerAddToCart) {
            innerAddToCart.setAttribute("disabled", "disabled");
            const innerBtn = innerAddToCart.querySelector("button");
            if (innerBtn) innerBtn.textContent = "Select Shade";
          }
        });
        soldOutButton.classList.add("hidden");
        addToCart.classList.remove("hidden")
        addToCart.removeAttribute("disabled");
        const btn = addToCart.querySelector("button");
        if (btn) {
          btn.textContent = "Add to kit";
        }
      }
    }
    else{
      if (soldOutButton) {
          soldOutButton.classList.remove("hidden");
          soldOutButton.setAttribute("disabled", "disabled");
          addToCart.classList.add("hidden")
      }
    }
  }
};


{
  window.GiftButton = () => {
    const giftBtn = document.querySelector('.gift_cart_button_wrapper');
    if (giftBtn && !giftBtn.classList.contains('js-listener-attached')) {
      giftBtn.classList.add('js-listener-attached');
      giftBtn.addEventListener('click', () => {
        document.querySelector('.quick-cart__container')?.classList.remove('cart_empty');
        document.querySelector('.quick-cart__container')?.classList.add('gift-drawer-open');
        document.querySelector('.quick-cart__wrapper')?.classList.add('gift-drawer-open');
      });
    }

    const closeBtn = document.querySelector('.gift_cart_close');
    if (closeBtn && !closeBtn.classList.contains('js-listener-attached')) {
        closeBtn.classList.add('js-listener-attached');
        closeBtn.addEventListener('click', () => {
        document.querySelector('.quick-cart__container')?.classList.add('cart_empty');
        document.querySelector('.quick-cart__container')?.classList.remove('gift-drawer-open');
        document.querySelector('.quick-cart__wrapper')?.classList.remove('gift-drawer-open');
      });
    }

    const doneBtn = document.querySelector('.gift_cart_done_button');
    if (doneBtn && !doneBtn.classList.contains('js-listener-attached')) {
        doneBtn.classList.add('js-listener-attached');
        doneBtn.addEventListener('click', () => {
        document.querySelector('.quick-cart__container')?.classList.add('cart_empty');
        document.querySelector('.quick-cart__container')?.classList.remove('gift-drawer-open');
        document.querySelector('.quick-cart__wrapper')?.classList.remove('gift-drawer-open');
      });
    }
  }
}

window.mainCartGiftSwiper = () => {
  const swiper = new Swiper('.main_cart_gift_swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: false,
    breakpoints: {
      0: { slidesPerView: 'auto', spaceBetween: 0 },
      320: { slidesPerView: 'auto', spaceBetween: 0 },
      720: { slidesPerView: 'auto', spaceBetween: 16 },
      960: { slidesPerView: 'auto', spaceBetween: 16 },
      1024: { slidesPerView: 'auto', spaceBetween: 16 },
      1200: { slidesPerView: 'auto', spaceBetween: 16 },
    },
  });
  const detailsEl = document.querySelector('.main_cart_gift details');

  if (detailsEl) {
    detailsEl.addEventListener('toggle', function () {
      if (detailsEl.open) {
        setTimeout(() => {
          swiper.update();
        }, 100);
      }
    });
  }
}


window.setCartGiftWidth = () => {
  let section = document.querySelector('.main_cart_gift_inner');  
  if (section) {
    let sectionHeight = section.offsetWidth + 'px';
    document.documentElement.style.setProperty('--main-cart-gift-width', sectionHeight);
  }
}
window.addEventListener('resize', setCartGiftWidth); 

(function () {
  const OVERFLOW_CLASS = 'product-swatches-options__item--overflow';
  const SWATCH_SELECTOR = '.js-swatch-limit';
  const LIST_SELECTOR = '.js-desktop-swatch';

  function outerWidth(el) {
    const rect = el.getBoundingClientRect();
    const cs = window.getComputedStyle(el);
    return rect.width + parseFloat(cs.marginLeft || 0) + parseFloat(cs.marginRight || 0);
  }

  function ensureOverflowLi(listContainer) {
    let overflowLi = listContainer.querySelector('.' + OVERFLOW_CLASS);
    if (!overflowLi) {
      overflowLi = document.createElement('li');
      overflowLi.className = `product-swatches-options__item ${OVERFLOW_CLASS}`;
      overflowLi.style.flex = '0 0 auto';
      overflowLi.style.order = 25;
      listContainer.appendChild(overflowLi);
    }
    return overflowLi;
  }

  function renderContainer(container) {
  const parentContainer =
    container.querySelector('.js-grid-wrapper') ||
    container.querySelector('.js-swatch-grid');

  const productUrl = container.dataset.url || '#';
  const listContainer = parentContainer?.querySelector(LIST_SELECTOR);
  if (!parentContainer || !listContainer) return;

  const swatches = Array.from(listContainer.querySelectorAll(SWATCH_SELECTOR));
  if (!swatches.length) return;

  const cs = window.getComputedStyle(listContainer);
  const gapX =
    parseFloat(cs.columnGap || cs.gap || '0') ||
    0;

  const overflowLi = ensureOverflowLi(listContainer);
  overflowLi.style.display = 'none';
  overflowLi.innerHTML = '';

  swatches.forEach(s => (s.style.display = 'flex'));

  const availableWidth = parentContainer.clientWidth;
  let used = 0;
  let limit = 0;

  const addWithGap = (current, nextWidth, index) =>
    current + nextWidth + (index > 0 ? gapX : 0);

  for (let i = 0; i < swatches.length; i++) {
    const w = outerWidth(swatches[i]);
    const projected = addWithGap(used, w, i);
    if (projected <= availableWidth - 28) {
      used = projected;
      limit++;
    } else {
      break;
    }
  }

  swatches.forEach((s, i) => (s.style.display = i < limit ? 'flex' : 'none'));

  const hiddenCount = Math.max(0, swatches.length - limit);

  if (hiddenCount > 0) {
    const a = document.createElement('a');
    a.href = productUrl;
    a.title = `+${hiddenCount} more`;
    a.setAttribute('aria-label', `+${hiddenCount} more`);
    a.textContent = `+${hiddenCount}`;
    overflowLi.appendChild(a);
    overflowLi.style.display = 'flex';

    let visibleWidth = 0;
    for (let i = 0; i < limit; i++) {
      visibleWidth = addWithGap(visibleWidth, outerWidth(swatches[i]), i);
    }

    const overflowW = outerWidth(overflowLi);
    const gapBeforeOverflow = limit > 0 ? gapX : 0;

    let finalLimit = limit;
    while (
      finalLimit > 0 &&
      (visibleWidth - (outerWidth(swatches[finalLimit - 1]) + (finalLimit - 1 > 0 ? gapX : 0))
        + gapBeforeOverflow + overflowW) > availableWidth + 0.5
    ) {
      visibleWidth -= outerWidth(swatches[finalLimit - 1]);
      if (finalLimit - 1 > 0) visibleWidth -= gapX;
      finalLimit--;
    }

    swatches.forEach((s, i) => (s.style.display = i < finalLimit ? 'flex' : 'none'));

    const finalHidden = Math.max(0, swatches.length - finalLimit);
    a.textContent = `+${finalHidden}`;
    a.title = `+${finalHidden} more`;
    a.setAttribute('aria-label', `+${finalHidden} more`);
  } else {
    overflowLi.style.display = 'none';
  }
}


  function renderAll() {
    document.querySelectorAll('.js-product-card').forEach(renderContainer);
  }

  function attachResizeObservers() {
    // Check for elements that haven't been observed yet to prevent memory leaks
    const wrappers = document.querySelectorAll('.js-product-card .js-grid-wrapper:not([data-observed]), .js-product-card .js-swatch-grid:not([data-observed])');
    if (!wrappers.length) return;

    const ro = new ResizeObserver(() => {
      requestAnimationFrame(renderAll);
    });
    wrappers.forEach(w => {
      ro.observe(w);
      w.setAttribute('data-observed', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    renderAll();
    attachResizeObservers();

    // Use MutationObserver instead of setInterval to efficienty detect new content (stops infinite polling)
    const observer = new MutationObserver((mutations) => {
      const hasAddedNodes = mutations.some(m => m.addedNodes.length > 0);
      if (hasAddedNodes) attachResizeObservers();
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener('resize', renderAll);
})();


{
  let mainwrappers = document.querySelectorAll(".js-featured-product");

  if (mainwrappers.length > 0) {
    mainwrappers.forEach(function(mainwrapper) {
      mainwrapper.addEventListener("click", function (e) {
        if (e.target && e.target.closest(".js-klaviyo-btn")) {
          e.preventDefault();
          
          const variantInput = mainwrapper.querySelector('select[name="id"], input[name="id"]');
          const variantId = variantInput ? variantInput.value : "";
          
          // Scope the link search to the current wrapper to find the correct PDP URL
          let linkEl = mainwrapper.querySelector(".js-link");
          let jsLink = linkEl ? linkEl.href : ""; 

          if (!jsLink || !variantId) return;

          let mainurl = `${jsLink}${jsLink.includes('?') ? '&' : '?'}variant=${variantId}`;
          sessionStorage.setItem("js-featured-product", "true");
          window.location.href = mainurl;
        }
      });
    });
  }

  if (sessionStorage.getItem("js-featured-product")) {
    let intervalId = setInterval(() => {
      let klaviyoBtn = document.querySelector(".product__info-container .js-klaviyo-btn, .product-form .js-klaviyo-btn");
      
      if (klaviyoBtn && !klaviyoBtn.classList.contains('visually-hidden') && klaviyoBtn.offsetParent !== null) {      
        klaviyoBtn.click();
        sessionStorage.removeItem("js-featured-product");
        clearInterval(intervalId);
      }
    }, 300);
  }
}


{
  const boxSadowElement = document.querySelector(".js-box-shadow-down");
  const scrollElement = document.querySelector(".quick-cart__main-content");
  const boxShadowUp = document.querySelector(".js-box-shadow-up");
  
  if (boxSadowElement && scrollElement && boxShadowUp) {
    const handleScrollShadows = function () {
      if (scrollElement.scrollTop > 10) {
        boxSadowElement.classList.add("box-shadow-down");
      } else {
        boxSadowElement.classList.remove("box-shadow-down");
      }
      if (scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight > 5) {
        boxShadowUp.classList.add("box-shadow-up");
      } else {
        boxShadowUp.classList.remove("box-shadow-up");
      }
    };

    scrollElement.addEventListener("scroll", handleScrollShadows);
    handleScrollShadows();
  }
}